import { ICellRendererParams } from 'ag-grid-community';
import { FileText } from 'lucide-react';
import { TokenBalance } from '../../types';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'src/components/ui/tooltip';

export const ContractCellRenderer = (
  params: ICellRendererParams<TokenBalance>,
) => {
  const token = params.data;

  if (!token?.token_address) {
    return <span className="text-muted-foreground">-</span>;
  }

  const address = token.token_address;
  const truncatedAddress = `${address.slice(0, 4)}...${address.slice(-4)}`;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger>
          <div className="flex items-center gap-2">
            <FileText className="h-4 w-4 text-muted-foreground" />
            <span className="font-mono text-foreground">
              {truncatedAddress}
            </span>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p className="font-mono">{address}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
